<app-auth-header></app-auth-header>

<div
  class="relative h-[93%] bg-cover bg-center text-white flex items-center justify-center bg-[rgb(76,151,212)]"
  style="background-image: url('assets/images/home_bg_img.png')"
>
  <div class="absolute inset-0 bg-[#272c36] bg-opacity-80"></div>

  <div
    class="fixed z-10 flex justify-center w-[70vw] !top-[6.25rem] h-[83vh] max-h-[calc(106vh-170px)] overflow-y-auto bg-[#F1F3F5]"
  >
    <div class="mt-[2rem] ml-[5rem] mr-[5rem] mb-[1rem] w-[100%]">
      <h2
        class="text-[#21252A] !font-roboto !text-[1.5rem] !mb-0 !font-bold !leading-[120%] !tracking-[-0.018em]"
      >
        <mat-icon
          class="!text-[#21252A] pt-[3px] font-semibold cursor-pointer ml-[-26px]"
          (click)="back()"
          >chevron_left</mat-icon
        >

        Payment Details
      </h2>

      <h6 class="!text-[#21252A] !text-[1.25rem] !font-bold !mb-0">
        Organization Name
      </h6>

      <h6 class="!text-[#21252A] !text-[1rem] !font-bold">
        Medium Plan ( Description )
      </h6>
      <div class="flex justify-between">
        <form [formGroup]="paymentdetails" (ngSubmit)="onSubmit()">
          <div class="w-[36.37rem] space-y-[14px]">
            <!-- card holder name -->
            <div class="flex items-center justify-between">
              <mat-form-field class="w-[377px] h-[66px]" appearance="outline">
                <mat-label>Card Holder Name</mat-label>
                <input
                  matInput
                  required
                  id="CardHolderName"
                  formControlName="CardHolderName"
                  type="text"
                  placeholder="Card Holder Name"
                  class="bg-[#F1F3F5] text-[#21252A] rounded-[10px]"
                />
                <mat-error
                  *ngIf="
                    paymentdetails.get('CardHolderName')?.touched &&
                    paymentdetails.get('CardHolderName')?.invalid
                  "
                >
                  <span
                    *ngIf="paymentdetails.get('CardHolderName')?.errors?.['required']"
                  >
                    This field is required
                  </span>
                </mat-error>
              </mat-form-field>
            </div>
            <!-- Card Number -->
            <div class="flex items-center justify-between">
              <mat-form-field class="w-[377px] h-[66px]" appearance="outline">
                <mat-label>Card Number</mat-label>
                <input
                  matInput
                  required
                  id="CardNumber"
                  formControlName="CardNumber"
                  type="text"
                  placeholder="Credit Card Number"
                  class="bg-[#F1F3F5] text-[#21252A] rounded-[10px]"
                />
                <mat-error
                  *ngIf="
                    paymentdetails.get('CardNumber')?.touched &&
                    paymentdetails.get('CardNumber')?.invalid
                  "
                >
                  <span
                    *ngIf="paymentdetails.get('CardNumber')?.errors?.['required']"
                  >
                    This field is required
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <div class="flex items-center justify-between">
              <div class="relative w-[377px]">
                <input
                  required="required"
                  id="CardExpiry"
                  formControlName="CardExpiry"
                  type="number"
                  oninput="this.value = this.value.slice(0, 2);"
                  class="w-16 bg-[#F1F3F5] text-[#21252A] border-[1px] border-[#21252A] pl-[15px] h-[44px] rounded-[4px] py-[10px] flex-shrink-0"
                  placeholder="MM"
                  min="1"
                  max="12"
                />

                <input
                  required="required"
                  id="CardExpiry "
                  formControlName="CardExpiry"
                  type="number"
                  maxlength="2"
                  min="1"
                  oninput="this.value = this.value.slice(0, 4);"
                  class="w-16 ml-3 bg-[#F1F3F5] text-[#21252A] border-[1px] border-[#21252A] pl-[20px] h-[44px] rounded-[4px] py-[10px] flex-shrink-0"
                  placeholder="YY"
                />
                <label
                  for="CVC "
                  class="text-[#21252A] text-[18px] font-bold ml-7"
                  >CVC
                </label>
                <input
                  required="required"
                  id="CVC"
                  formControlName="CVC"
                  maxlength="3"
                  type="text"
                  class="w-[159px] ml-2 bg-[#F1F3F5] text-[#21252A] border-[1px] border-[#203D54] text-center pl-[15px] pr-[15px] h-[44px] rounded-[4px] py-[10px] flex-shrink-0"
                  placeholder="123"
                />
                <div
                  *ngIf="
                    paymentdetails.get('CVC')?.touched &&
                    paymentdetails.get('CVC')?.invalid
                  "
                >
                  <span
                    *ngIf="paymentdetails.get('CVC')?.errors?.['required']"
                    class="text-red-500 text-sm ml-[210px]"
                  >
                    This field is required
                  </span>
                </div>
              </div>
            </div>
            <!-- address line 1 -->
            <div class="flex items-center justify-between">
              <mat-form-field class="w-[377px] h-[66px]" appearance="outline">
                <mat-label>Address Line 1</mat-label>
                <input
                  matInput
                  required
                  id="AddressLine1"
                  formControlName="AddressLine1"
                  type="text"
                  placeholder="Address Line 1"
                  class="bg-[#F1F3F5] text-[#21252A] rounded-[10px]"
                />
                <mat-error
                  *ngIf="
                    paymentdetails.get('AddressLine1')?.touched &&
                    paymentdetails.get('AddressLine1')?.invalid
                  "
                >
                  <span
                    *ngIf="paymentdetails.get('AddressLine1')?.errors?.['required']"
                  >
                    This field is required
                  </span>
                </mat-error>
              </mat-form-field>
            </div>

            <!-- address line 2 -->
            <div class="flex items-center justify-between">
              <mat-form-field class="w-[377px] h-[66px]" appearance="outline">
                <mat-label>Address Line 2</mat-label>
                <input
                  matInput
                  id="AddressLine2"
                  formControlName="AddressLine2"
                  type="text"
                  placeholder="Address Line 2"
                  class="bg-[#F1F3F5] text-[#21252A] rounded-[10px]"
                />
              </mat-form-field>
            </div>

            <!-- country -->
            <div class="flex items-center justify-between">
              <div class="!min-w-[377px] h-[66px]">
                <!-- <app-country
                  class="w-[100%]"
                ></app-country> -->
                <mat-form-field class="w-[377px] h-[66px]" appearance="outline">
                  <mat-label>country</mat-label>
                  <mat-select
                    required
                    id="country"
                    formControlName="country"
                    class="text-[#21252A] rounded-[10px]"
                  >
                    <mat-option
                      *ngFor="let country of countries"
                      [value]="country"
                    >
                      {{ country }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      paymentdetails.get('country')?.touched &&
                      paymentdetails.get('country')?.invalid
                    "
                  >
                    <span
                      *ngIf="paymentdetails.get('country')?.errors?.['required']"
                    >
                      This field is required
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="flex items-center">
              <!-- state/province -->
              <div class="flex items-center">
                <mat-form-field class="w-[150px] h-[66px]" appearance="outline">
                  <mat-label>State/Province</mat-label>
                  <mat-select
                    required
                    id="StateProvince"
                    formControlName="StateProvince"
                    class="text-[#21252A] rounded-[10px]"
                  >
                    <mat-option *ngFor="let state of states" [value]="state">
                      {{ state }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      paymentdetails.get('StateProvince')?.touched &&
                      paymentdetails.get('StateProvince')?.invalid
                    "
                  >
                    <span
                      *ngIf="paymentdetails.get('StateProvince')?.errors?.['required']"
                    >
                      This field is required
                    </span>
                  </mat-error>
                </mat-form-field>
              </div>
              <!-- City -->
              <mat-form-field
                class="w-[155px] ml-[70px] h-[66px]"
                appearance="outline"
              >
                <mat-label>City</mat-label>
                <input
                  matInput
                  required
                  id="city"
                  formControlName="city"
                  type="text"
                  placeholder="City"
                  class="bg-[#F1F3F5] text-[#21252A] rounded-[10px]"
                />
                <mat-error
                  *ngIf="
                    paymentdetails.get('city')?.touched &&
                    paymentdetails.get('city')?.invalid
                  "
                >
                  <span
                    *ngIf="paymentdetails.get('city')?.errors?.['required']"
                  >
                    This field is required
                  </span>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </form>
        <div class="flex flex-col justify-between">
          <div class="flex justify-end">
            <div>
              <div class="image-upload-container">
                <div
                  class="uploaded-image w-[207px] h-[192px] flex justify-center items-center mt-[-85px] cursor-pointer"
                  (click)="triggerFileInput()"
                  style="
                    border: 2px solid rgba(32, 61, 84, 0.2);
                    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
                  "
                >
                  <!-- Conditionally show the uploaded image if imageUrl is available -->
                  <img
                    *ngIf="imageUrl; else placeholder"
                    [src]="imageUrl"
                    alt="Uploaded Image"
                    class="w-full h-full object-contain"
                  />

                  <!-- Placeholder image if no imageUrl -->
                  <ng-template #placeholder>
                    <img
                      src="assets/icons/org_logo_icon.svg"
                      alt="org logo"
                      class="w-full h-full object-contain"
                    />
                  </ng-template>
                </div>

                <input
                  type="file"
                  #fileInput
                  (change)="onFileSelected($event)"
                  accept="image/*"
                  style="display: none"
                />

                <div class="text-center mt-[8px] w-[207px]">
                  <span class="text-[#21252A] text-[18px] font- font-semibold"
                    >Organization Logo</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-black static align-bottom flex justify-end !mb-5">
        <div class="flex">
          <button
            (click)="back()"
            class="flex w-[114px] cursor-pointer h-[48px] justify-center items-center flex-shrink-0 bg-[#F1F3F5] border-[2px] border-[#E76B3F] rounded-[0.3125rem] text-[#E76B3F] font-semibold text-[16px] ml-[18px]"
            style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
          >
            Back
          </button>

          <button
            (click)="navigateToDashboard()"
            class="flex bg-[#E76B3F] text-[#F1F3F5] w-[114px] h-[48px] justify-center items-center flex-shrink-0 rounded-[0.3125rem] font-semibold text-[16px] cursor-pointer ml-[23px]"
            style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
          >
            Pay
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
